import React, { useState } from "react";
import {
  useTranslation,
  WithTranslation,
  withTranslation,
} from "react-i18next";
import { IShoppingCartItem } from "../../models/IShoppingCartModel";
import { DefaultImg } from "../../components/images";
import ProductGiftsModal from "../../components/productInformation/productInformationGift/productGiftsModal";
import { KEY_SHOPPING_CART } from "../../common/constant";
import { useDispatch } from "react-redux";
import { actionClearShoppingCart } from "../../redux/reducers/slice/cart";

interface IGiftItemProps extends WithTranslation {
  item: IShoppingCartItem;
}

const GiftItem = ({ item }: IGiftItemProps) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [currentPromotion, setCurrentPromotion] = useState<any>({});
  const dispatch = useDispatch();
  const promotions = (item && item.gift_promotions) || [];

  if (promotions.length == 0) {
    return null;
  }

  const handleClose = () => setVisible(false);

  const handleChange = (featureId: any, newOpt: any) => {
    const giftSelected = {
      ...currentPromotion,
      default_prop: newOpt.spec_id,
      product: { ...currentPromotion.product, img: newOpt.img },
    };

    const promotionsUpdate = promotions.map((p: any) => {
      if (p._id === currentPromotion._id) {
        p = giftSelected;
      }
      return p;
    });

    let cartInfo = JSON.parse(localStorage.getItem(KEY_SHOPPING_CART) || "");
    cartInfo.items = cartInfo.items.map((cartItem: any) => {
      if (cartItem._id === item._id) {
        cartItem = { ...cartItem, gift_promotions: promotionsUpdate };
      }
      return cartItem;
    });

    localStorage.setItem(KEY_SHOPPING_CART, JSON.stringify(cartInfo));

    dispatch(actionClearShoppingCart());

    setCurrentPromotion(giftSelected);
    setVisible(false);
  };

  const showModal = (promotion: any) => {
    setVisible(true);
    setCurrentPromotion(promotion);
  };

  return (
    <>
      {promotions.map((gift: any, index: number) => (
        <div key={`gift-item-info-${index}`} className="gift-item-container">
          <div className="gift-item-wrapper">
            <div className="gift-product-info-wrapper">
              <span
                className="product-name sub-content"
                title={gift.product.name}>
                {gift.product.name}
              </span>
              {!!(Array.isArray(gift.options) && gift.options.length) && (
                <span
                  className="product-spec sub-content"
                  title={gift.product_name_extra}>
                  {
                    gift.options.find(
                      (item: any) => item.spec_id === gift.default_prop
                    ).name
                  }
                </span>
              )}
              <span
                className="product-spec sub-content"
                title={gift.product_name_extra}>
                {gift.product_name_extra}
              </span>
              {/* {gift.sealed_price !== "0" && (
                <span className="product-spec sub-content">
                  {t("label_gift_price")}:{" "}
                  <span style={{ fontWeight: 500 }}>
                    {gift.sealed_price} VND
                  </span>
                </span>
              )} */}
            </div>
            <div
              className={`gift-product-image-wrapper ${
                !gift.options.length ? "gift-no-change" : ""
              }`}>
              {gift.product.img ? (
                <img src={gift.product.img} title={gift.product.name} />
              ) : (
                <img src={DefaultImg} title={gift.product.name} />
              )}
              {gift.options.length ? (
                <a
                  className="btn-re-choose-spec"
                  onClick={() => showModal(gift || {})}>
                  <span>{t("label_reselect")}</span>
                </a>
              ) : null}
            </div>
          </div>
        </div>
      ))}
      <ProductGiftsModal
        handleClose={handleClose}
        handleChange={handleChange}
        promotion={currentPromotion}
        visible={visible}
      />
    </>
  );
};

export default withTranslation()(GiftItem);
